import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { vin } from '../Vin';

export const useVinMovements = () =>
  useQuery({
    queryKey: [QUERY_KEYS.vesselMovements],
    queryFn: async () => (await vin.getVinMovements()).data,
  });
